import { useRouter } from 'next/router';
import { useState } from 'react';

import useFile from '@/hooks/queries/file/useFile';
import NotFoundErrorModal from '@/components/User/_components/common/NotFoundErrorModal';
import NavHeader from '@/components/User/_components/common/NavHeader';
import ProPlanUpgradeModal from '@/components/User/_components/common/ProPlanUpgradeModal';

import Navigation from '../../Navigation';

import OneToOne from './OneToOne';
import Bulk from './Bulk';

const TrackingClients = () => {
  const router = useRouter();

  const fileId = Number(router.query.fileId);

  const [isNotFoundModalOpen, setIsNotFoundModalOpen] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const { data: fileData } = useFile(
    { fileId },
    {
      enabled: Boolean(fileId),
      select: (data) => data.data.data.file,
      onError: (error) => {
        if (error?.response?.status === 404) {
          setIsNotFoundModalOpen(true);
        } else if (error?.response?.status === 403) {
          setIsUpgradeModalOpen(true);
        }
      },
      retry: 1,
    },
  );

  return (
    <div>
      <NavHeader>
        <Navigation />
      </NavHeader>
      {fileData?.isBulk ? <Bulk /> : <OneToOne />}
      <NotFoundErrorModal
        isModalOpen={isNotFoundModalOpen}
        setModalOpen={setIsNotFoundModalOpen}
      />
      {isUpgradeModalOpen && (
        <ProPlanUpgradeModal onOpenChange={setIsUpgradeModalOpen} />
      )}
    </div>
  );
};

export default TrackingClients;
